module.exports = __webpack_public_path__ + "img/tk.ad2a946d.png";